<template>
  <BaseModal modal-id="modalAlert" :sessionModal="true" :show-modal="showSessionModalInactive" :allow-esc="bindEscKey">
    <template #heading>{{ modalDetails.header }} 
    </template>
    <template #content>
      <div class="app-modal-basic">
        <img src="@ridmv/web-themes/images/icons/exclamation-triangle-solid.svg" alt="">
        <div class="message-ext">
          <p>Your session will expire in<span class="timeRemaining"> {{ formattedTime }} </span>seconds.</p>
          <p>{{ modalDetails.descriptionText }}</p>
        </div>
      </div>
    </template>
    <template #footing>
      <BaseButtonGroup>
        <template #default>
          <button @click.prevent="handleLogoutButton()">
            {{ modalDetails.logoutButtonText }}
          </button>
          <button class="app-btn-primary" @click.prevent="handleContinueSessionButton()">
            {{ modalDetails.continueSessionButtonText }}
          </button>
        </template>
      </BaseButtonGroup>
    </template>
  </BaseModal>
</template>

<script setup>
import { ref, watch, onUnmounted, computed } from 'vue';
import { useStore } from 'vuex';
import BaseModal from '@/components/ui/BaseModal';
import BaseButtonGroup from '@/components/ui/BaseButtonGroup';
import * as COMMONS from '../../store/_commons';

// Props and emits
const props = defineProps({
  showSessionModalInactive: Boolean,
  onTimeout: Function,
});

const emit = defineEmits(['getShowInactiveStatus']);

// Vuex store
const store = useStore();

const bindEscKey = ref(false);
const modalDetails = ref({
  header: 'You are inactive for 15 minutes',
  descriptionText: "Please click on 'Continue session' or click 'Log Out' to end your session immediately.",
  continueSessionButtonText: 'Continue session',
  logoutButtonText: 'Log Out',
  modalType: 'expired',
});
const timeRemaining = ref(60);
const timerId = ref(0);

const formattedTime = computed(() => {
  const seconds = timeRemaining.value;
  return seconds < 10 ? `0${seconds}` : String(seconds);
});

// Computed property for Vuex getter

// Watcher
watch(
  () => props.showSessionModalInactive,
  (newValue) => {
    if (newValue) {
      timeRemaining.value = 60;
      startTimer();
    } else {
      clearTimeout(timerId.value);
      timeRemaining.value = 60;
    }
  }
);

const handleContinueSessionButton = () => {
  clearTimeout(timerId.value);
  emit('getShowInactiveStatus', false);
  timeRemaining.value = 60;
};

const handleLogoutButton = () => {
  store.dispatch(COMMONS.GUEST_LOGIN_GET_LOGOUT);
  emit('getShowInactiveStatus', false);
};

const startTimer = () => {
  clearInterval(timerId.value); 

  timerId.value = setInterval(() => {
    if (props.showSessionModalInactive && timeRemaining.value > 0) {
      timeRemaining.value -= 1;
      if (timeRemaining.value === 0) {
        clearInterval(timerId.value);
        if (props.onTimeout) {
            props.onTimeout();
        }
      }
    } else {
      // If modal is suddenly hidden or already zero, stop the interval
      clearInterval(timerId.value);
    }
  }, 1000);
};

// Lifecycle hook 
onUnmounted(() => {
  clearTimeout(timerId.value);
});

defineExpose({
  startTimer,
});
</script>


<style lang="scss" scoped>
// TODO: should have been picked up from @ridmv/web-themes but it's not...
.app-modal-basic {
  display: flex;
  align-items: flex-start;
  img {
    margin: 0.7em 0.5em 0 0;
    width: 1.25rem;
  }

  .message-ext {
  p {
    color: black;
  }}
  .timeRemaining {
    display: inline-block;
    width: 30px;
    text-align: center;
    @extend %font-sans-bold;
    font-size: 1.25rem;
  }
}
button {
  margin-bottom: 1.125em;
  &:not(:last-child) {
    margin-right: 1em;
  }
  &.disabled {
    cursor: not-allowed;
    opacity: 0.7;
  }
}
</style>